/**
 * §7 — the platform-wide matter-name vocabulary powering the New-Case "Assunto"
 * combobox suggestions. One org-scoped list (platform rows + the caller-org's
 * own org-private rows), so the query key carries no id. Vocabulary changes
 * slowly (a new row only on a genuinely-new matter name), so a long staleTime is
 * fine. Backend contract: matter-vocabulary handback §3.
 */

import { useQuery } from "@tanstack/react-query";
import { fetchMatterVocabulary, type MatterVocabularyRow } from "@/lib/lexserver-client";

export function useMatterVocabulary() {
  return useQuery<MatterVocabularyRow[], Error>({
    queryKey: ["matter-vocabulary"],
    queryFn: fetchMatterVocabulary,
    staleTime: 5 * 60_000,
    retry: 2,
  });
}
